import { connect } from "react-redux"
import { formValueSelector } from "redux-form"
import ProductModal from "../../components/shop/product/modal"

const selectProductValue = formValueSelector("shop-product")

const mapStateToProps = state => {
  const {newProduct, editProductId, sortedItemIds} = state.currentShop.productList
  const {products} = state.entities
  const initialValues = editProductId ? products[editProductId] : {type: "product"}
  const availableGroups = []
  sortedItemIds.forEach(id => {
    const productItem = products[id]
    if (productItem && productItem.type === "group") availableGroups.push(productItem)
  })
  return {
    editProductId,
    initialValues,
    isOpen: newProduct || !!editProductId,
    products,
    availableGroups,
    type: selectProductValue(state, "type")
  }
}

const mapDispatchToProps = dispatch => ({
  onCancel: () => dispatch({type: "SHOP.CANCEL_PRODUCT_MODAL"}),
  onSubmit: (payload) => dispatch({type: "SHOP.SUBMIT_PRODUCT", payload}),
})

export default connect(mapStateToProps, mapDispatchToProps)(ProductModal)

